module.exports = __webpack_public_path__ + "img/p65.adc89d57.jpg";